export default __webpack_public_path__ + "static/media/file-document.975d0976.svg";